import type { JsonSchema } from '#src/utils/jsonSchema.ts';

import raw from './webhook.schema.json' with { type: 'json' };

export const webhookSchema = raw as JsonSchema;
